/**
 * 杭加-数据
 */
//浙江杭加泽通建筑节能新材料有限公司

// const videoUrl = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/video/hangjia.mp4";
const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
const videoUrl = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/m2/hangjia.mp4";
//荣誉证书
const hangjiaC = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/hangjiaC.png";
const hangjiaC1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/hangjiaC1.jpg";
const hangjiaC2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/hangjiaC2.jpg";
const hangjiaC3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/hangjiaC3.jpg";
//资质证书
const hangjiaQ1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/hangjiaQ1.png";
const hangjiaQ2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/hangjiaQ2.png";
const hangjiaQ3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/hangjiaQ3.png";
const hangjiaQ4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/home/hangjiaQ4.jpg";

const hjDetails1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/hangjia/detail1.jpg";
const hjDetails2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/hangjia/detail2.jpg";

const hjCase1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/hangjia/case1.png";
const hjCase2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/list/hangjia/case2.png";
// new
const hjzz1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjzz1.jpg";
const hjzz2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjzz2.jpg";
const hjzz3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjzz3.jpg";
const hjzz4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjzz4.jpg";
const hjzz5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjzz5.jpg";
const hjzz6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjzz6.jpg";
const hjzz7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjzz7.jpg";

const hjry1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjry1.jpg";
const hjry2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjry2.jpg";
const hjry3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjry3.jpg";
const hjry4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjry4.jpg";
const hjry5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjry5.jpg";
const hjry6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjry6.png";
const hjry7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjry7.jpg";

const hjcp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjcp1.png";
const hjcp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjcp2.png";
const hjcp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjcp3.png";
const hjbg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjbg1.png";

const hjlb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjlb1.jpg";
const hjlb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjlb2.jpg";
const hjlb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjlb3.jpg";
const hjlb4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjlb4.jpg";
const hjlb5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjlb5.png";

const hjgc1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjgc1.png";
const hjgc2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjgc2.png";
const hjgc3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjgc3.png";
const hjgc4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjgc4.png";
const hjgc5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjgc5.png";
const hjgc6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjgc6.png";
const hjgc7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjgc7.png";
const hjht1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht1.png";
const hjht2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht2.png";
const hjht3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht3.png";
const hjht4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht4.png";
const hjht5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht5.png";
const hjht6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht6.png";
const hjht7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht7.png";
const hjht8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht8.png";
const hjht9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht9.png";
const hjht10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht10.png";
const hjht11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht11.png";
const hjht12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht12.png";
const hjht13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjht13.png";
export default {
	homeData: {
		herderBanner: [hjlb1, hjlb2, hjlb3, hjlb4, hjlb5],
		//企业logo
		logo:
			"https://ss1.baidu.com/6ONXsjip0QIZ8tyhnq/it/u=3218430523,254919849&fm=179&app=42&f=JPEG?w=300&h=300&s=4D261D72EB884CC85C5160D4000010B2",
		//企业Vr背景
		vRlogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjgs1.png",
		isShowVrModal: true,
		vRurl: "https://skyeye.aupup.com/factory/full-view?factoryId=777&supplierId=777",
		isShowVr: false,
		isVideo: false,
		videoLogo: "https://b2b-web-real-field.bj.bcebos.com//prod_real/place_img/0bacac0da65ff79df238243f7a506f5e",
		videoUrl: videoUrl,
		//首页banner
		bannerHeight: "900px",
		banner: [
			"https://b2b-web-real-field.bj.bcebos.com//prod_real/place_img/0bacac0da65ff79df238243f7a506f5e",
			"https://b2b-web-real-field.bj.bcebos.com//prod_real/place_img/2ec802e4df8e75317b3c71ef527baad5",
			"https://b2b-web-real-field.bj.bcebos.com//prod_real/place_img/4bd3f33e482f1f9985578b9fdba044a6",
		],
		//企业介绍
		overview:
			"浙江杭加泽通建筑节能新材料有限公司（简称“杭加新材”）始创于1976年，注册资金1.5个亿，总部位于杭州市富阳区渔山工业园区。公司为富春控股集团下属子公司，是首家采用国内设备生产AAC板材并率先在民用建筑中推广应用AAC板材的企业。公司长期投入加气混凝土产品的研发和应用，主导产品包括高品质的AAC板材、ACB砌块以及绿色建筑系统房屋集成化、一体化服务及整体解决方案等。公司服务于百家名企，产品蜚声",
		//公司官网
		website: "http://www.hga-aac.com/",
		//经营品类
		categories: "蒸压加气混凝土板/蒸压加气混凝土加气块",
		//公司地址
		companyAddress: "浙江省杭州市富阳区渔山工业区",
		site: "浙江省杭州市",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "60000万人民币",
		//成立日期
		establishment: "2012-04-19",
		//经营品牌
		brand: "杭加",
		//主营产品
		mainProducts: "杭加alc板;ALC板材;增压加气混凝土板;AAC板;轻质隔墙板",
		//企业名称
		headerTitle: "浙江杭加泽通建筑节能新材料有限公司",
		moreInfoName: "杭加泽通",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: "1.现款现结  2.按工程进度付款",
		//工厂地址
		factoryAddress: "浙江省杭州市富阳区渔山工业区",
		//工厂人数
		factoryHeadcount: "1200人",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",
		//联系负责人
		person: "展洪波 先生 ",
		//联系电话
		contactNumber: "18906509788",
		email: "zhanhongbo@forchn.com.cn",
		//资质证书
		qualificationList: [
			{
				name: "安全生产标准化证书",
				path: hjzz1,
			},
			{
				name: "环境管理体系证书",
				path: hjzz2,
			},
			{
				name: "绿色建材评价标识证书",
				path: hjzz3,
			},
			{
				name: "营业执照",
				path: hjzz4,
			},
			{
				name: "浙江制造认证证书",
				path: hjzz5,
			},
			{
				name: "职业健康安全管理体系证书",
				path: hjzz6,
			},
			{
				name: "质量管理体系证书",
				path: hjzz7,
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "高企证书2022年",
				path: hjry1,
			},
			{
				name: "建材供应商总和实力评测（SCI）",
				path: hjry2,
			},
			{
				name: "建材企业500强",
				path: hjry3,
			},
			{
				name: "质量管理先进单位",
				path: hjry4,
			},
			{
				name: "质量信誉模范企业",
				path: hjry5,
			},
			{
				name: "质量信誉模范企业",
				path: hjry6,
			},
			{
				name: "中国加气混凝土协会副会长单位",
				path: hjry7,
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "万科企业股份有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjhb2.png",
				desc: "",
			},
			{
				name: "绿城房地产集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjhb3.png",
				desc: "",
			},
			{
				name: "中国建筑集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjhb4.png",
				desc: "",
			},
			{
				name: "中国铁路工程集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjhb5.png",
				desc: "",
			},
			{
				name: "中民筑友科技集团",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjhb6.png",
				desc: "",
			},
			{
				name: "龙湖地产有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjhb7.png",
				desc: "",
			},
			{
				name: "中南建设集团有限公司 ",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjhb8.png",
				desc: "",
			},
			{
				name: "上海建工集团股份有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjhb9.png",
				desc: "",
			},
			{
				name: "华为技术有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/hangjia/hjhb10.png",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 27,
				num: 0,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 1127,
				num: 0,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "36亿+",
				num: 24,
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [
			{
				name: "陕西津达线缆制造有限公司",
				jumpParameter: "津达",
				site: "陕西省西咸新区沣西新城创业路以南",
				path: "https://img2.baidu.com/it/u=1571152657,2720896384&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500",
				capital: "人民币12000万元",
				business: "电线; 电缆; 电力电缆;",
			},
			{
				name: "陕西川百煜集成房屋有限公司",
				jumpParameter: "川百煜",
				site: "陕西省渭南市富平县庄里镇西上官村",
				path: "https://img.trustexporter.com/202112/23/083010562007719.png",
				capital: "人民币800万元",
				business:
					"建筑材料销售；集装箱制造；金属结构制造；五金产品零售；建筑装饰材料销售；卫生洁具销售；门窗销售；建筑防水卷材产品销售；集装箱销售；集装箱租赁服务",
			},
		],
	},
	listData: {
		productList: [
			{ name: "杭加艺术板", img: hjcp1 },
			{ name: "蒸压加气混凝土板", img: hjcp2 },
			{ name: "杭加管线一体板", img: hjcp3 },
		],
		aim: "杭加.绿色建筑行家",
		navList: [
			{
				name: "杭加艺术板",
				isShow: false,
				children: ["杭加艺术板A3.5B05"],
			},
			{
				name: "蒸压加气混凝土板",
				isShow: false,
				children: ["蒸压加气混凝土板A3.5B05/A5.0B06"],
			},
			{
				name: "杭加管线一体板",
				isShow: false,
				children: ["杭加管线一体板A3.5B05"],
			},
		],
	},
	productDetailsData: {
		杭加艺术板: {
			name: "杭加艺术板",
			img: hjcp1,
			modelNumber: [
				{
					title: "蒸压加气混凝土墙板",
					img: hjcp1,
				},
			],
			price: "--",
			detailImgs: [hjcp1],
			report: [],
			modelNumberText: "A3.5B05",
			brand: "杭加",
			describe:
				"杭加AAC艺术板艺术板是杭加为符合个性化设计研发的一种新型板材，是以普通板材为基础，采用数控计算机控制刀具加工形成的效果各异的板材，板材还会通过专用涂料进行上色，以达到最佳的立面效果。",
		},

		蒸压加气混凝土板: {
			name: "蒸压加气混凝土板",
			img: hjcp2,
			modelNumber: [
				{
					title: "蒸压加气混凝土墙板",
					img: hjcp2,
				},
			],
			price: "800元",
			detailImgs: [hjcp2],
			report: [hjbg1],
			modelNumberText: "A3.5B05/A5.0B06",
			brand: "杭加",
			describe:
				"产品可广泛应用于住宅、办公楼、医院、宾馆、学校等各类民用、公共、工业建筑，几乎可以用在建筑物围护结构的所有部位。（1）特性：具有节能环保、轻质、抗震、防火、无毒等众多传统材料所不具备的优势。（2）可选厚度：50mm、75mm、100mm、125mm、150mm、200mm",
		},

		杭加管线一体板: {
			name: "杭加管线一体板",
			img: hjcp3,
			modelNumber: [
				{
					title: "蒸压加气混凝土墙板",
					img: hjcp3,
				},
			],
			price: "--",
			detailImgs: [hjcp3],
			report: [],
			modelNumberText: "A3.5B05",
			brand: "杭加",
			describe:
				"免开槽蒸压加气混凝土板：简称ALC免开槽内墙板、在传统的ALC内墙板基础上，在墙板内按定位要求预留灯具、开光及接线位置，在开关、插座及对接位置间预留20线管及孔洞，避免现场的管线开槽及修补。",
		},
	},
	contactListData: {
		list: [
			{
				name: "周显友",
				position: "销售经理（陕西省、西安省、重庆）",
				id: "2",
				phoneNum: "13452395123",
				color: "#007DFF ",
				email: "zhouxianyou@forcn.com.cn",
			},
		],
	},
	caseData: {
		list: [
			{
				name: "上海青浦研发生产项目",
				id: 1,
				price: "7332万",
				time: "2022",
				site: "上海市青浦区",
				type: "厂房",
				unit: "中建三局集团有限公司",
				desc:
					"华为上海青浦研发中心位于青浦区金泽镇西岑社区，是长三角示范区西岑科创中心的重要项目。其中f组团位于整个华为研发项目西北侧，东临园区水系，在规划设计中借鉴了美国波士顿的规划理念，通过曲折丰富的景观路网，打造成以中央临水广场和核心放射型“广场小镇”组团。项目总建筑面积达23万平方米，共14栋单体，包括研发用房及数据中心，配套普通实验室及员工服务设施。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hjgc2 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hjht2 },
					{ title: "", path: hjht3 },
				],
				product: "ALC板材安装；蒸压加气混凝土墙板",
			},

			{
				name: "西安团结安置社区及配套项目",
				id: 2,
				price: "533万",
				time: "2022",
				site: "陕西省西安市未央区",
				type: "住宅",
				unit: "陕西建工第五建设集团有限公司",
				desc:
					"团结片区安置社区及配套项目是全国第一批城市更新试点城市西安的重点项目，项目有仁宇路以北、仁谨路以南、景云路以东、聚德路以西6个地块以及永庆路东西2个地块，总建筑面积92.81万平方米，居住总人数1.6万人，总投资约43.5亿元。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hjgc3 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hjht4 },
					{ title: "", path: hjht5 },
				],
				product: " ALC板材安装；蒸压加气混凝土墙板",
			},

			{
				name: "隆港城建安工程二标段",
				id: 3,
				price: "623万",
				time: "2022",
				site: "陕西省西安市高新区",
				type: "住宅",
				unit: "陕西建工第十二建设集团有限公司",
				desc:
					"隆港城建安工程二标段项目位于西安市高新区兴隆三路以北，规划一路以西。建筑面积124107.96㎡，包含6栋高层住宅、1栋商业公建以及南区地下车库，结构形式为装配式叠合板+剪力墙结构。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hjgc4 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hjht6 },
					{ title: "", path: hjht7 },
				],
				product: "  ALC板材安装；蒸压加气混凝土墙板",
			},

			{
				name: "天地源玖玺香都",
				id: 4,
				price: "200万",
				time: "2022",
				site: "重庆市九龙坡区",
				type: "住宅",
				unit: "陕西建工集团股份有限公司",
				desc: "天地源玖玺香都位于九龙坡火炬大道，总建设用地面积26175平方米，建筑面积约为74621平方米。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hjgc5 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hjht8 },
					{ title: "", path: hjht9 },
				],
				product: "  ALC板材安装；蒸压加气混凝土墙板",
			},

			{
				name: "华南理工大学广州国际校区二期",
				id: 5,
				price: "1000万",
				time: "2021",
				site: "广州市番禺区",
				type: "学校",
				unit: "中国建筑第五工程局有限公司",
				desc:
					"华南理工大学广州国际校区二期工程位于广州市番禺区南村兴业大道以北，市新路以东，场地右侧为待建的规划南村大道，G5装配式教师公寓地块位于华南理工大学广州国际校区东部，共10栋建筑，其中8栋为装配式建筑， 2栋为全现浇建筑，总建筑面积15万㎡。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hjgc6 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hjht10 },
					{ title: "", path: hjht11 },
				],
				product: "  ALC板材安装；蒸压加气混凝土墙板",
			},

			{
				name: "厦门国际健康驿站（保障性租赁住房）项目",
				id: 6,
				price: "2272万",
				time: "2021",
				site: "厦门湖里区",
				type: "医院",
				unit: "中建一局集团东南建设有限公司",
				desc:
					" 保障性租赁住房（厦门国际健康驿站）项目位于湖里区航空港工业与物流园区内港中路北侧，计划总投资233543万元。占地面积约13.6万平方米，总建筑面积约35.88万平方米。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: hjgc7 }],
				// 合作证明图
				contractList: [
					{ title: "", path: hjht12 },
					{ title: "", path: hjht13 },
				],
				product: "  ALC板材安装；蒸压加气混凝土墙板",
			},
		],
	},
	evaluationData: {
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: true,
				number: 3,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${14}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${14}.png`,
				title: "绿建认证",
				// subtitle: "管理体系认证",
				isShow: true,
			},

			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${2}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${2}.png`,
				title: "建材企业500强",
				isShow: true,
			},
		],
	},
	successfulBidderData: {
		info: [
			{
				name1: "华南ALC材料集中采购 ",
				name2: "华南ALC材料集中采购",
				name3: "物资采购",
				date: "2020-10-9",
			},
		],
	},
	lawData: {
		info: [
			{
				caseName: "浙江杭加泽通建筑节能新材料有限公司、宁波市辰枫建材有限公司等买卖合同纠纷执行实施类执行通知书",
				reference: "（2022）浙0111执2346号",
				cause: "买卖合同纠纷",
				identity: "申请执行人",
				caseType: "执行案件",
				date: "2022-10-18",
			},
			{
				caseName: "浙江杭加泽通建筑节能新材料有限公司、宁波市辰枫建材有限公司等买卖合同纠纷一审民事判决书",
				reference: "（2022）浙0111民初1037号",
				cause: "买卖合同纠纷",
				identity: "原告",
				caseType: "民事案件",
				date: "2022-06-28",
			},
			{
				caseName: "王付强、浙江杭加泽通建筑节能新材料有限公司等提供劳务者受害责任纠纷民事一审民事裁定书",
				reference: "（2021）鄂0902民初4716号",
				cause: "提供劳务者受害责任纠纷",
				identity: "被告",
				caseType: "民事案件",
				date: "2021-11-24",
			},
		],
	},
	tipData: {
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立10年以上",
			},
			{
				title: "高新技术企业",
			},
		],
	},
};
